export default "__VITE_ASSET__DD1y$XmM__"